import React from 'react';
import { DEFAULT_GENERIC_RULES } from '../constants/competition';
import { normalizeRulesList } from '../utils/rules';

function ClubRulesSettings({ API, canEditClubRules, canEditSiteRules, club, clubDefaultsMap, clubId, clubRulesDraft, clubs, genericRulesDraft, isAllClubs, isDefaultClub, onRulesLibraryChange, setClubDefaultsMap, setClubRulesDraft, setGenericRulesDraft, setSiteDefaults, showToast, siteDefaults }) {
  return (
    <>
      <div className="w3-card w3-round w3-white w3-margin-bottom">
        <div className="w3-container w3-theme-d4 w3-round-top" style={{ padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 700 }}><i className="fa fa-university w3-margin-right"></i>Site Generic Rules</span>
          {canEditSiteRules && (
            <button className="w3-button w3-tiny w3-theme-l2 w3-round" onClick={async () => {
              const payload = { ...(siteDefaults || {}), rulesLibraryGeneric: normalizeRulesList(genericRulesDraft, 'site') };
              const r = await fetch(`${API}/api/auth/site-comp-defaults`, {
                method: 'PUT', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ defaults: payload }),
              });
              if (!r.ok) return showToast('Failed to save site rules', 'red');
              const saved = await r.json();
              setSiteDefaults(saved || null);
              const nextGeneric = normalizeRulesList((saved && saved.rulesLibraryGeneric) || DEFAULT_GENERIC_RULES, 'site');
              setGenericRulesDraft(nextGeneric);
              if (onRulesLibraryChange) onRulesLibraryChange(nextGeneric, clubRulesDraft);
              showToast('Site rules saved');
            }}>
              <i className="fa fa-save w3-margin-right"></i>Save Site Rules
            </button>
          )}
        </div>
        <div className="w3-container w3-padding">
          <p className="w3-small w3-text-grey" style={{ marginTop: 0 }}>
            Default rules used across clubs. Super-admin edits these in All Clubs mode.
          </p>
          {genericRulesDraft.map((rule, i) => (
            <div key={`${rule.id}-${i}`} className="w3-border-bottom" style={{ padding: '8px 0' }}>
              {canEditSiteRules ? (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr auto', gap: '6px', alignItems: 'center' }}>
                  <input className="w3-input w3-border w3-round w3-small" value={rule.title}
                    onChange={e => setGenericRulesDraft(prev => prev.map((r, idx) => idx === i ? { ...r, title: e.target.value } : r))} />
                  <input className="w3-input w3-border w3-round w3-small" value={rule.detail || ''}
                    onChange={e => setGenericRulesDraft(prev => prev.map((r, idx) => idx === i ? { ...r, detail: e.target.value } : r))} />
                  <button className="w3-button w3-tiny w3-round w3-light-grey w3-hover-red"
                    onClick={() => setGenericRulesDraft(prev => prev.filter((_, idx) => idx !== i))}>
                    <i className="fa fa-trash"></i>
                  </button>
                </div>
              ) : (
                <div>
                  <strong>{rule.title}</strong>
                  {rule.detail ? <div className="w3-small w3-text-grey">{rule.detail}</div> : null}
                </div>
              )}
            </div>
          ))}
          {canEditSiteRules && (
            <button className="w3-button w3-tiny w3-theme-l4 w3-round" style={{ marginTop: '8px' }}
              onClick={() => setGenericRulesDraft(prev => [...prev, { id: `site-${Date.now()}`, title: 'New Rule', detail: '', source: 'site' }])}>
              <i className="fa fa-plus w3-margin-right"></i>Add Site Rule
            </button>
          )}
        </div>
      </div>

      {!isAllClubs && (
        <div className="w3-card w3-round w3-white w3-margin-bottom">
          <div className="w3-container w3-theme-d4 w3-round-top" style={{ padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontWeight: 700 }}><i className="fa fa-bookmark w3-margin-right"></i>{club ? club.name : 'Club'} Custom Rules</span>
            {canEditClubRules && (
              <button className="w3-button w3-tiny w3-theme-l2 w3-round" onClick={async () => {
                const existing = clubDefaultsMap[clubId] || {};
                const payload = { ...existing, rulesLibraryClubCustom: normalizeRulesList(clubRulesDraft, 'club') };
                const r = await fetch(`${API}/api/auth/clubs/${clubId}/comp-defaults`, {
                  method: 'PUT', headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ defaults: payload }),
                });
                if (!r.ok) return showToast('Failed to save club rules', 'red');
                const saved = await r.json();
                setClubDefaultsMap(prev => ({ ...prev, [clubId]: saved || null }));
                const nextClub = normalizeRulesList((saved && saved.rulesLibraryClubCustom) || [], 'club');
                setClubRulesDraft(nextClub);
                if (onRulesLibraryChange) onRulesLibraryChange(genericRulesDraft, nextClub);
                showToast('Club rules saved');
              }}>
                <i className="fa fa-save w3-margin-right"></i>Save Club Rules
              </button>
            )}
          </div>
          <div className="w3-container w3-padding">
            {isDefaultClub && <p className="w3-small w3-text-grey"><em>Default Club rules are read-only. Select a real club to customize.</em></p>}
            {clubRulesDraft.length === 0 && <p className="w3-small w3-text-grey"><em>No club custom rules yet.</em></p>}
            {clubRulesDraft.map((rule, i) => (
              <div key={`${rule.id}-${i}`} className="w3-border-bottom" style={{ padding: '8px 0' }}>
                {canEditClubRules ? (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr auto', gap: '6px', alignItems: 'center' }}>
                    <input className="w3-input w3-border w3-round w3-small" value={rule.title}
                      onChange={e => setClubRulesDraft(prev => prev.map((r, idx) => idx === i ? { ...r, title: e.target.value } : r))} />
                    <input className="w3-input w3-border w3-round w3-small" value={rule.detail || ''}
                      onChange={e => setClubRulesDraft(prev => prev.map((r, idx) => idx === i ? { ...r, detail: e.target.value } : r))} />
                    <button className="w3-button w3-tiny w3-round w3-light-grey w3-hover-red"
                      onClick={() => setClubRulesDraft(prev => prev.filter((_, idx) => idx !== i))}>
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                ) : (
                  <div>
                    <strong>{rule.title}</strong>
                    {rule.detail ? <div className="w3-small w3-text-grey">{rule.detail}</div> : null}
                  </div>
                )}
              </div>
            ))}
            {canEditClubRules && (
              <button className="w3-button w3-tiny w3-theme-l4 w3-round" style={{ marginTop: '8px' }}
                onClick={() => setClubRulesDraft(prev => [...prev, { id: `club-${Date.now()}`, title: 'New Club Rule', detail: '', source: 'club' }])}>
                <i className="fa fa-plus w3-margin-right"></i>Add Club Rule
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default ClubRulesSettings;
